import React from "react";
import { Modal, Button, IconWarningAlt } from "@veneer/core";

interface CourseFailedModalProps {
  show: boolean;
  onClose: () => void;
  score: number;
  t: (key: string) => string;
}

export const CourseFailedModal: React.FC<CourseFailedModalProps> = ({
  show,
  onClose,
  score,
  t,
}) => {
  return (
    <div style={{ position: "relative" }}>
      <Modal
        className="modalFailedCourse"
        align="center"
        id="modalFailedCourse"
        show={show}
        onClose={onClose}
        footer={
          <Button onClick={onClose} appearance="primary">
            {t("header.closebutton")}
          </Button>
        }
        title={t("header.failedCourse")}
      >
        <IconWarningAlt size={120} />
        <br />
        <p>
          {t("header.score")}:{" " + score}%
        </p>
        <b>{t("header.alertFailedCourse")}</b>
      </Modal>
    </div>
  );
};
